export default {"src":"/_next/static/media/NoStakeholderTable.08607201.svg","height":165,"width":172,"blurWidth":0,"blurHeight":0};